import styled from '@emotion/styled'

const ImgRect = styled.div`
  ${({ theme, $selected }) => `
    position: relative;
    padding-top: 100%;
    width: 58px;
    height: 58px;
    padding: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${$selected ? theme.palette.primary.main : 'transparent'};
    box-sizing: border-box;
    cursor: pointer;
  `}
`
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const PhotoThumb = ({ photo, isSelected, onClick }) => {
  return (
    <ImgRect $selected={isSelected} onClick={onClick}>
      <Img src={photo?.image?.url} alt={photo?.description} />
    </ImgRect>
  )
}

export default PhotoThumb
